import type { UpdateSelectionAction } from '..';

import updateSelection from './updateSelection';

const resetSelection = (): UpdateSelectionAction => updateSelection([]);

export default resetSelection;
